import "./style.scss";
import { styles } from "@repo/helpers";

import { Props } from "./types";

export function Row(props: Props) {
	const { tag = "div" } = props;
	const Tag = tag;
	const className = styles(props.className, "row");

	return (
		<Tag {...props} className={className}>
			{props.children}
		</Tag>
	);
}

export default Row;
